import Link from 'next/link';
import { usePathname } from 'next/navigation';
import clsx from 'clsx';
import { NavItem } from '../Header/Header';

const NavMenu = ({ links }: { links: NavItem[] }) => {
    const pathname = usePathname();

    return (
        <div className="flex justify-between w-full py-2">
            {links.map((link, idx) => {
                // Add an active class if the link is active
                const isActiveClass =
                    pathname === link.path ? 'bg-neutral-200' : '';

                const linkClasses = clsx(
                    'relative',
                    'inline-flex',
                    'items-center',
                    'tap-highlight-transparent',
                    'outline-none',
                    // Leaving these commented out for now
                    // 'data-[focus-visible=true]:z-10',
                    // 'data-[focus-visible=true]:outline-2',
                    // 'data-[focus-visible=true]:outline-focus',
                    // 'data-[focus-visible=true]:outline-offset-2',
                    'text-medium',
                    'text-primary',
                    'no-underline',
                    'hover:opacity-80',
                    'active:opacity-disabled',
                    'transition-opacity',
                    'p-2',
                    'px-4',
                    'bg-neutral-100',
                    'rounded-lg',
                    'hover:bg-neutral-200',
                    'whitespace-nowrap',
                    isActiveClass
                );

                return (
                    <Link
                        key={idx}
                        className={linkClasses}
                        href={link.path as string}
                    >
                        {link.label}
                    </Link>
                );
            })}
        </div>
    );
};

export default NavMenu;
